import { render, staticRenderFns } from "./ggsygs.vue?vue&type=template&id=67b64a46&scoped=true&"
import script from "./ggsygs.vue?vue&type=script&lang=js&"
export * from "./ggsygs.vue?vue&type=script&lang=js&"
import style0 from "./ggsygs.vue?vue&type=style&index=0&id=67b64a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b64a46",
  null
  
)

export default component.exports